import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.attributes || initialState;

export const selectAttributesError = createSelector(
  [selectSlice],
  state => state.error,
);
export const selectAttributesData = createSelector(
  [selectSlice],
  state => state.data,
);
export const selectAttributesIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
